import { render, staticRenderFns } from "./balance-history.pug?vue&type=template&id=5c133ff3&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./balance-history.scss?vue&type=style&index=0&id=5c133ff3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c133ff3",
  null
  
)

export default component.exports